import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Riwayat Redeem")
], -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, _createSlots({
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.route.meta.permission.read)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_InputIconRightGrey, {
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
                  placeholder: "Cari Disini ...",
                  canClick: true,
                  onSubmitInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchData(_ctx.inputSearch))),
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
                  type: _ctx.$enumBase.input.text,
                  icon: _ctx.$icon.svg.searchEva
                }, null, 8, ["modelValue", "type", "icon"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (_ctx.route.meta.permission.read)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createVNode(_component_DataTable, {
                value: _ctx.data,
                paginator: false,
                class: "table-og",
                responsiveLayout: "scroll"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "Nama Akun" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode("p", {
                        class: "color-primary font-semibold cursor-pointer",
                        onClick: ($event: any) => (_ctx.printRedeem(slotProps.data.Id))
                      }, _toDisplayString(slotProps.data.Name), 9, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Tanggal Klaim" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.moment(slotProps.data.CreatedAt).format("DD MMMM YYYY")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Kode Voucher" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.MyVoucherGuid), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Jenis Voucher" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.JenisBarang), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Alamat" }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.Note), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              (_ctx.data.length > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 0,
                    rows: _ctx.filter.pageSize,
                    totalRecords: _ctx.filter.totalRecords,
                    onPage: _ctx.onPage
                  }, null, 8, ["rows", "totalRecords", "onPage"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1024),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          edit: _ctx.route.meta.permission.update,
          onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editData(_ctx.dataForm)))
        }, null, 8, ["edit"])
      ]),
      _: 1
    }, 512)
  ]))
}